import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { Icon } from '@/shared/ui';

import styles from './ConsultationNotice.module.scss';

type ConsultationNoticeProps = {
  title: ReactNode;
  message: ReactNode;
  className?: string;
};

/**
 * Recording-level warning shown once at the top of the consultation page
 * (no speech detected, recording interrupted). Presentational only: each
 * notice decides on its own when it applies.
 */
export const ConsultationNotice: FC<ConsultationNoticeProps> = ({
  title,
  message,
  className,
}) => (
  <div className={cn(styles.container, className)} role="alert">
    <Icon className={styles.icon} name="info" size={24} />
    <div className={styles.content}>
      <p className={cn('p3', styles.title)}>{title}</p>
      <p className={cn('p4', styles.message)}>{message}</p>
    </div>
  </div>
);
